<template>

  <div>

    <el-form :model="appForm" :rules="rules" ref="appForm" style="margin-right: 30px;">

      <el-form-item label="App名" :label-width="formLabelWidth" prop="name">
        <el-input v-model="appForm.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="平台" :label-width="formLabelWidth" prop="platform">

        <el-select style="margin-right: 30px" v-model="appForm.platform" filterable placeholder="请选择平台">
          <el-option
            v-for="item in platformList"
            :key="item.id"
            :label="item.name"
            :value="item.value" :index="item.id">
          </el-option>
        </el-select>

      </el-form-item>


      <el-form-item label="包名" :label-width="formLabelWidth" prop="bundleId">
        <el-input v-model="appForm.bundleId" autocomplete="off"></el-input>
      </el-form-item>


      <el-form-item :label-width="formLabelWidth" label="">
        <div style="margin-right: 30px;">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="confirmAction('appForm')">确 定</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'AddApp',
    props: {
      editAppForm: {
        type: Object,
        default: {}
      }
    },
    watch: {
      editAppForm (newValue, oldValue) {

        this.appForm = newValue
        console.log(this.appForm)
      }
    },
    methods: {
      closeDialog () {
        this.$emit('clickCancel')
      },
      confirmAction (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.closeDialog()
            // this.clearData()
            this.$emit('clickConfirm', this.appForm)
          } else {
            return false
          }
        })
      },
    },
    data () {
      return {
        rules: {
          name: [
            {
              required: true,
              message: '请输入App名',
              trigger: 'blur'
            }
          ],
          platform: [
            {
              required: true,
              message: '请选择平台',
              trigger: 'blur'
            }
          ],
          bundleId: [
            {
              required: true,
              message: '请填写包名',
              trigger: 'change'
            }
          ]
        },
        formLabelWidth: '100px',
        platformList: [
          {
            id: 'iOS',
            value: '1',
            name: 'iOS'
          },
          {
            id: 'Android',
            value: '2',
            name: 'Android'
          }
        ],
        appForm: this.editAppForm
      }
    }
  }
</script>

<style scoped>

</style>
